// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".581.0.0." + {2239: "0b74df397c6677de",2733: "57cda5672cbbc76f",2944: "e9472c429b79b7b9",5233: "19dfdf89c34bc663",5338: "1ddf0dd168a9ed88",8756: "fa40d95005bf52e2",9289: "7006b2c389b07016",}[chunkId] + ".css"
}